import {
    Modal
} from "@mui/material";
import React, {RefObject, useEffect,  useState} from "react";
import {Survey} from "src/models/survey";
import {isNil} from "lodash";
import SurveyWrapper from "./survey";



interface SurveyModalProps {
  surveys: Survey[];
  currentVideoTimeMs: number;
  videoRef: RefObject<HTMLVideoElement>;
}

export default function SurveyModal({
    surveys,
    currentVideoTimeMs,
    videoRef
}: SurveyModalProps) {


    // const [surveyIdx, setSurveyIdx] = useState<number>(0);
    // const [questionIdx, setQuestionIdx] = useState<number>(0);

    const [survey,changeSurvey] = useState<Survey>();


    useEffect(() => {
        if (!videoRef.current) {
            changeSurvey(undefined);
            return;
        }
        const currentSurvey =  surveys.find(survey => {
            const videoCurrentTime = Math.round(videoRef.current.currentTime) * 1000;
            return videoCurrentTime >= survey.surveyStartMillis && videoCurrentTime < survey.surveyStartMillis + 1000;
        });
        if (currentSurvey) {
            videoRef.current.pause();
            if (document.fullscreenElement) {
                document
                    .exitFullscreen()
                    .then(() => console.log("Document Exited form Full screen mode"))
                    .catch((err) => console.error(err));
            }
        }
        changeSurvey(currentSurvey);
    }, [videoRef, currentVideoTimeMs, surveys]);



    const handleCloseSurvey = () => {
        changeSurvey(undefined);
        if (videoRef.current) {
            videoRef.current.currentTime = videoRef.current.currentTime + 1;

            videoRef.current.play().catch(err => {
                console.error(err);
            });
        }
    };

    if (isNil(survey)) {
        return null;
    }
    return  (
        <Modal
            open
            closeAfterTransition
            disableEscapeKeyDown
            slotProps={{
                backdrop: {style: {backdropFilter: "blur(10px)"}}
            }}
        >
            <SurveyWrapper onFinish={handleCloseSurvey} key={survey.surveyId} item={survey}/>
        </Modal>
    );
}
